export const quizQueryKeys = {
  detail: (code: string) => ["quiz", "detail", code] as const,
  results: (code: string) => ["quiz", "results", code] as const,
};
